{
  "level": "eb04",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:eb04",
    "objects": "AREAS.E3:eb04.e3",
    "mesh": "TREES.E3:eb04.e3"
  },
  "spawn_point": {
    "position": [
      1762.865955171131,
      1518.452415829613,
      194.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      1762.865955171131,
      1618.452415829613,
      194.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      1730.0,
      1496.5,
      170.0
    ],
    "bbox_max": [
      1845.251220703125,
      1559.9998779296875,
      380.0
    ],
    "vertex_count": 21,
    "vertices": [
      [
        1845.251220703125,
        1555.0,
        177.5
      ],
      [
        1838.18017578125,
        1550.0001220703125,
        185.0
      ],
      [
        1842.322265625,
        1559.9998779296875,
        170.0
      ],
      [
        1845.251220703125,
        1555.0,
        177.5
      ],
      [
        1838.18017578125,
        1550.0001220703125,
        170.0
      ],
      [
        1731.0,
        1496.5,
        374.0
      ],
      [
        1731.0,
        1496.5,
        380.0
      ],
      [
        1730.5003662109375,
        1502.0,
        380.0
      ],
      [
        1730.0,
        1504.5001220703125,
        380.0
      ],
      [
        1730.5,
        1504.5001220703125,
        380.0
      ],
      [
        1730.9998779296875,
        1504.5001220703125,
        380.0
      ],
      [
        1730.9998779296875,
        1504.5001220703125,
        374.0
      ],
      [
        1730.9998779296875,
        1504.5001220703125,
        380.0
      ],
      [
        1731.0,
        1512.5,
        380.0
      ],
      [
        1730.0,
        1512.5,
        380.0
      ],
      [
        1758.0,
        1512.5,
        380.0
      ],
      [
        1768.0,
        1512.5,
        380.0
      ],
      [
        1758.0,
        1512.5,
        370.0
      ],
      [
        1758.0,
        1512.5,
        380.0
      ],
      [
        1731.0,
        1512.5,
        374.0
      ],
      [
        1731.0,
        1512.5,
        380.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1768.0,
      "bbox_min": [
        1729.9998779296875,
        1479.9998779296875,
        170.0
      ],
      "bbox_max": [
        1910.0,
        1572.5001220703125,
        392.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -8.719300694792764e-07,
        1.0,
        0.0
      ],
      "plane_d": -1479.998291015625,
      "bbox_min": [
        1768.0,
        1479.9998779296875,
        170.0
      ],
      "bbox_max": [
        1910.0,
        1572.5001220703125,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        1768.0,
        1500.0,
        170.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1572.5001220703125,
        384.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1499.9998779296875,
      "bbox_min": [
        1768.0,
        1500.0,
        370.0
      ],
      "bbox_max": [
        1771.0,
        1510.0,
        384.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 382.0,
      "bbox_min": [
        1768.0,
        1500.0,
        382.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1510.0,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1572.5001220703125,
        185.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        0.5547002553939819
      ],
      "plane_d": -1371.496337890625,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1572.5001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.539208253438119e-06,
        0.8320503234863281,
        -0.5547002553939819
      ],
      "plane_d": -1174.572998046875,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1572.5001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320565223693848,
        -0.5546908378601074
      ],
      "plane_d": 1392.3055419921875,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1572.5001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866402268409729,
        0.32584214210510254,
        -0.5244274735450745
      ],
      "plane_d": 1037.9500732421875,
      "bbox_min": [
        1838.18017578125,
        1550.0001220703125,
        170.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1572.5001220703125,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866410613059998,
        0.325840562582016,
        0.5244271755218506
      ],
      "plane_d": 851.782470703125,
      "bbox_min": [
        1842.322265625,
        1555.0,
        170.0
      ],
      "bbox_max": [
        1852.5001220703125,
        1572.5001220703125,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.539227352826856e-06,
        -0.8320565223693848,
        0.5546908378601074
      ],
      "plane_d": 1195.3856201171875,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1845.251220703125,
        1559.9998779296875,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866410613059998,
        0.325840562582016,
        0.5244271755218506
      ],
      "plane_d": 851.782470703125,
      "bbox_min": [
        1838.18017578125,
        1550.0001220703125,
        170.0
      ],
      "bbox_max": [
        1845.251220703125,
        1559.9998779296875,
        177.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866402268409729,
        0.32584214210510254,
        -0.5244274735450745
      ],
      "plane_d": 1037.9500732421875,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1845.251220703125,
        1555.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7866410613059998,
        0.325840562582016,
        0.5244271755218506
      ],
      "plane_d": 851.782470703125,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1845.251220703125,
        1555.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -8.137954864650965e-06,
        -3.3908476325450465e-05
      ],
      "plane_d": -1769.981201171875,
      "bbox_min": [
        1768.0,
        1530.0,
        170.0
      ],
      "bbox_max": [
        1770.0,
        1555.0,
        185.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        6.103888154029846e-05,
        1.0,
        0.0
      ],
      "plane_d": -1537.6080322265625,
      "bbox_min": [
        1768.0,
        1537.5,
        170.0
      ],
      "bbox_max": [
        1770.0,
        1547.5,
        182.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1547.5,
      "bbox_min": [
        1768.0,
        1537.5,
        170.0
      ],
      "bbox_max": [
        1770.0,
        1547.5,
        182.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 182.0,
      "bbox_min": [
        1768.0,
        1537.5,
        182.0
      ],
      "bbox_max": [
        1770.0,
        1547.5,
        182.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.781730462535052e-06,
        1.0,
        0.0
      ],
      "plane_d": -1532.511962890625,
      "bbox_min": [
        1729.9998779296875,
        1490.0,
        170.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1552.5,
        392.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 392.0,
      "bbox_min": [
        1729.9998779296875,
        1490.0,
        370.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1532.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1729.9998779296875,
        1490.0,
        370.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1532.5,
        392.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        1729.9998779296875,
        1490.0,
        370.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1532.5,
        392.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1730.0,
      "bbox_min": [
        1729.9998779296875,
        1490.0,
        370.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1532.5,
        392.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1496.5,
      "bbox_min": [
        1729.9998779296875,
        1494.0,
        370.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1532.5,
        392.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 391.5,
      "bbox_min": [
        1730.4998779296875,
        1494.0,
        370.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1496.5,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0001220703125,
        -0.0
      ],
      "plane_d": -1730.6826171875,
      "bbox_min": [
        1730.4998779296875,
        1494.0,
        370.0
      ],
      "bbox_max": [
        1733.0,
        1496.5,
        391.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -948.583740234375,
      "bbox_min": [
        1730.4998779296875,
        1494.0,
        374.0
      ],
      "bbox_max": [
        1733.0,
        1496.5,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1731.0,
        1494.0,
        374.0
      ],
      "bbox_max": [
        1731.0,
        1496.5,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.975495125516318e-06,
        1.0,
        -0.0
      ],
      "plane_d": -1504.51220703125,
      "bbox_min": [
        1729.9998779296875,
        1496.5,
        370.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1532.5,
        392.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 391.5,
      "bbox_min": [
        1730.0,
        1496.5,
        370.0
      ],
      "bbox_max": [
        1768.0,
        1504.5001220703125,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0001220703125,
        1.0,
        0.0
      ],
      "plane_d": -1498.2113037109375,
      "bbox_min": [
        1730.0,
        1496.5,
        370.0
      ],
      "bbox_max": [
        1733.0001220703125,
        1504.5001220703125,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1731.0,
        1496.5,
        374.0
      ],
      "bbox_max": [
        1731.0,
        1498.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.00012208521366119385,
        0.0
      ],
      "plane_d": -1730.6837158203125,
      "bbox_min": [
        1730.0,
        1502.0,
        370.0
      ],
      "bbox_max": [
        1733.0001220703125,
        1504.5001220703125,
        391.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        1730.0,
        1502.0,
        380.0
      ],
      "bbox_max": [
        1730.5003662109375,
        1504.5001220703125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        1730.5,
        1502.0,
        380.0
      ],
      "bbox_max": [
        1731.0,
        1504.5001220703125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1512.5,
      "bbox_min": [
        1729.9998779296875,
        1504.5001220703125,
        370.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1532.5,
        392.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 391.5,
      "bbox_min": [
        1729.9998779296875,
        1504.5001220703125,
        370.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1512.5,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        1729.9998779296875,
        1504.5001220703125,
        370.0
      ],
      "bbox_max": [
        1768.0,
        1512.5,
        391.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1758.0,
      "bbox_min": [
        1730.0,
        1504.5001220703125,
        370.0
      ],
      "bbox_max": [
        1758.0,
        1512.5,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1730.0,
        1504.5001220703125,
        370.0
      ],
      "bbox_max": [
        1731.0,
        1512.5,
        380.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.00012208521366119385,
        1.0,
        0.0
      ],
      "plane_d": -1506.211181640625,
      "bbox_min": [
        1730.0,
        1505.9998779296875,
        370.0
      ],
      "bbox_max": [
        1730.9998779296875,
        1512.5,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1730.5,
      "bbox_min": [
        1730.5,
        1511.5,
        370.0
      ],
      "bbox_max": [
        1730.5,
        1512.5,
        374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1730.5,
      "bbox_min": [
        1730.5,
        1511.5,
        380.0
      ],
      "bbox_max": [
        1733.0,
        1512.5,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -948.583740234375,
      "bbox_min": [
        1730.5,
        1511.5,
        389.0
      ],
      "bbox_max": [
        1733.0,
        1512.5,
        391.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.6991141314501874e-06,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.5064697265625,
      "bbox_min": [
        1730.0,
        1512.5,
        370.0
      ],
      "bbox_max": [
        1768.0,
        1532.5,
        392.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1764.0,
      "bbox_min": [
        1754.0,
        1530.5,
        370.0
      ],
      "bbox_max": [
        1764.0,
        1532.5,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1754.0,
      "bbox_min": [
        1754.0,
        1530.5,
        370.0
      ],
      "bbox_max": [
        1764.0,
        1532.5,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 382.0,
      "bbox_min": [
        1754.0,
        1530.5,
        382.0
      ],
      "bbox_max": [
        1764.0,
        1532.5,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3775233328342438,
        -0.9260000586509705,
        0.0
      ],
      "plane_d": 759.682861328125,
      "bbox_min": [
        1730.0,
        1512.5,
        370.0
      ],
      "bbox_max": [
        1768.0,
        1530.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9166505932807922,
        -0.3996894955635071,
        0.0
      ],
      "plane_d": -978.6640014648438,
      "bbox_min": [
        1733.5355224609375,
        1527.141357421875,
        370.0
      ],
      "bbox_max": [
        1735.0,
        1530.5,
        392.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1520.0,
      "bbox_min": [
        1730.0,
        1512.5,
        370.0
      ],
      "bbox_max": [
        1768.0,
        1520.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1758.0,
      "bbox_min": [
        1730.0,
        1512.5,
        370.0
      ],
      "bbox_max": [
        1768.0,
        1520.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        1758.0,
        1512.5,
        380.0
      ],
      "bbox_max": [
        1768.0,
        1520.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1731.0,
      "bbox_min": [
        1730.0,
        1512.5,
        374.0
      ],
      "bbox_max": [
        1731.0,
        1514.0001220703125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00012208521366119385,
        1.0,
        0.0
      ],
      "plane_d": -1514.2113037109375,
      "bbox_min": [
        1730.0,
        1512.5,
        374.0
      ],
      "bbox_max": [
        1731.0,
        1514.0001220703125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        1730.0,
        1512.5,
        380.0
      ],
      "bbox_max": [
        1731.0,
        1514.0001220703125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        6.103553459979594e-06,
        0.0
      ],
      "plane_d": -1750.009521484375,
      "bbox_min": [
        1750.0,
        1532.5,
        170.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1552.5,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1552.5,
      "bbox_min": [
        1750.0,
        1532.5,
        170.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1552.5,
        385.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 385.0,
      "bbox_min": [
        1750.0,
        1532.5,
        170.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1552.5,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        1750.0,
        1532.5,
        170.0
      ],
      "bbox_max": [
        1768.0001220703125,
        1552.5,
        170.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: elev1dr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev1dr2",
      "offset": 2259,
      "centroid": [
        1759.0,
        1531.5,
        376.0
      ],
      "bbox_min": [
        1754.0,
        1530.5,
        370.0
      ],
      "bbox_max": [
        1764.0,
        1532.5,
        382.0
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 2.0,
        "height_z": 12.0,
        "door_width": 10.0,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          1764.0,
          1532.5,
          382.0
        ],
        [
          1764.0,
          1532.5,
          370.0
        ],
        [
          1764.0,
          1530.5,
          382.0
        ],
        [
          1764.0,
          1530.5,
          370.0
        ],
        [
          1754.0,
          1532.5,
          370.0
        ],
        [
          1754.0,
          1532.5,
          382.0
        ],
        [
          1754.0,
          1530.5,
          382.0
        ],
        [
          1754.0,
          1530.5,
          370.0
        ]
      ],
      "plane_distance": -1532.5,
      "authentic_texture": "spkelevdoor1"
    }
  ],
  "tutorial_messages": []
}